import { config, mapTypes } from '@/config/config';
import { useMapDays } from '@/features/itinerary-map/hooks/use-map-days';
import { usePlaces } from '@/features/world-map/hooks/use-places';
import { fitBoundsToPlaces } from '@/utils/map';
import { useMap } from '@vis.gl/react-google-maps';
import classes from './reset-map-button.module.css';

/**
 * Reset button for World Map
 */
function WorldMapResetButton() {
  const places = usePlaces();
  const map = useMap();

  const resetMap = () => {
    fitBoundsToPlaces(map, places);
  };

  return (
    <button type="button" className={classes.resetBtn} onClick={resetMap} aria-label="Reset map to original view">
      <span>Re-center</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 30 30" fill="none">
        <path
          d="M21.5875 8.41244L16.2875 21.0749L14.6375 16.7999L14.2375 15.7624L13.2125 15.3624L8.925 13.6999L21.5875 8.41244ZM26.25 3.74994L3.75 13.1624V14.3874L12.3 17.6999L15.6 26.2499H16.825L26.25 3.74994Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}

/**
 * Reset button for Itinerary Map
 */
function ItineraryMapResetButton() {
  const itineraryDays = useMapDays();
  const map = useMap();

  // Transform itinerary days to match the places format for fitBoundsToPlaces
  const places =
    itineraryDays?.map((day) => ({ position: /** @type {[number, number]} */ (day.port?.position) })) ?? [];

  const resetMap = () => {
    fitBoundsToPlaces(map, places);
  };

  return (
    <button type="button" className={classes.resetBtn} onClick={resetMap} aria-label="Reset map to original view">
      <span>Re-center</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 30 30" fill="none">
        <path
          d="M21.5875 8.41244L16.2875 21.0749L14.6375 16.7999L14.2375 15.7624L13.2125 15.3624L8.925 13.6999L21.5875 8.41244ZM26.25 3.74994L3.75 13.1624V14.3874L12.3 17.6999L15.6 26.2499H16.825L26.25 3.74994Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}

/**
 * Main ResetMapButton that renders the appropriate version based on map type
 */
export function ResetMapButton() {
  return config.mapType === mapTypes.world ? <WorldMapResetButton /> : <ItineraryMapResetButton />;
}
